<template>
  <div
    data-qa="share_btn"
    class="d-flex align-center justify-center cursor-pointer bg-gray-0"
    :style="size ? {
      width: `${size}px`,
      height: `${size}px`,
    } : undefined"
    @click="handleShareClick"
  >
    <span class="ui-icon-share-circle ui-icon-fz-medium text-info--text" />
  </div>
</template>

<script lang="ts" setup>
import copy from 'copy-to-clipboard'
import i18next from 'i18next'
import useIsMobile from 'src/composables/useIsMobile'
import useYandexGoals from 'src/composables/useYandexGoals'
import useSnackbar from 'src/composables/useSnackbar'

const URL_NAMES_TO_GOAL_SOURCES = {
  town_vrach: 'doctorList',
  doctorlist: 'doctorList',
  doctor: 'doctor',
  lpu: 'lpu',
  town_lechenie: 'doctorListLechenie',
  online_town_vrach: 'doctorListOnline',
  online_doctorlist: 'doctorListOnline',
  town_lpu: 'lpuList',
  lpulist: 'lpuList',
  lpuset: 'lpuset',
}

type UrlName = 'town_vrach'
  | 'doctorlist'
  | 'doctor'
  | 'lpu'
  | 'town_lechenie'
  | 'online_town_vrach'
  | 'online_doctorlist'
  | 'town_lpu'
  | 'lpulist'
  | 'lpuset'
  | 'services_all'
  | 'services_category'

const props = defineProps<{
  url: string
  urlName: UrlName
  type: 'lpu' | 'doctor'
  size: number | string
}>()

const { t, language } = i18next
const options = { ns: language }

const isMobile = useIsMobile()

async function handleShareClick() {
  if (!isMobile.value) {
    copyToClipboard()
    return
  }

  try {
    await navigator.share({
      url: props.url,
    })

    sendGoal()
  } catch (error: any) {
    if (error.name === 'AbortError') {
      return
    }

    copyToClipboard()
  }
}

const { sendYaGoal } = useYandexGoals()

function sendGoal() {
  if (!props.urlName) {
    return
  }

  let goalSource: string
  const goalObjectType = props.type === 'lpu' ? 'lpu' : 'doctor'

  if (props.urlName === 'services_all' || props.urlName === 'services_category') {
    goalSource = window.location.href.includes('/diagnostika/') ? 'diagnostics' : 'services'
  } else {
    goalSource = URL_NAMES_TO_GOAL_SOURCES[props.urlName]
  }

  sendYaGoal(`shareButton_${goalObjectType}_${goalSource}`)
}

const snackbar = useSnackbar()

function copyToClipboard() {
  copy(props.url)

  snackbar.show(t('Ссылка скопирована', options))
  sendGoal()
}
</script>
